import { TyckaGraphqlClient } from './TyckaGraphqlClient/TyckaGraphqlClient';
import { TyckaRestClient } from './TyckaRestClient/TyckaRestClient';

import {
  TyckaConfig,
  SortOptions,
  ReviewResponse,
  ProductAverageRatingResponse,
  TransactionData,
  AuthorData,
  FieldsFormData,
} from './types';

export default class TyckaClient {
  private restClient: TyckaRestClient;
  private graphqlClient: TyckaGraphqlClient;

  constructor(config: TyckaConfig) {
    this.restClient = new TyckaRestClient(config);
    this.graphqlClient = new TyckaGraphqlClient(config);
  }

  public async fetchReviews(
    filter: { [key: string]: string },
    sortOptions: SortOptions[],
    pagination: { take: number; skip: number },
    lang: string,
    preview: boolean = false
  ): Promise<ReviewResponse> {
    return await this.restClient.fetchReviews(
      filter,
      sortOptions,
      pagination,
      lang,
      preview,
    );
  }

  public async fetchAverageRating(
    filter: { [key: string]: string },
    strict?: boolean
  ): Promise<ProductAverageRatingResponse> {
    return await this.restClient.fetchAverageRating(filter, strict);
  }

  public async fetchProductFields() {
    return await this.graphqlClient.fetchProductFields();
  }

  public async fetchTransactionData(
    fields: string[],
    itemId: string,
    transactionId: string,
    secret: string
  ) {
    return await this.graphqlClient.fetchTransactionData(
      fields,
      itemId,
      transactionId,
      secret
    );
  }

  public async fetchRelatedProductsData(
    fields: string[],
    itemIds: string[],
  ) {
    return await this.graphqlClient.fetchRelatedProductsData(
      fields,
      itemIds,
    );
  }

  public async createReview(
    formData: FieldsFormData,
    transactionData: TransactionData,
    authorData: AuthorData
  ) {
    return await this.graphqlClient.createReview(
      formData,
      transactionData,
      authorData
    );
  }
}
